export default __webpack_public_path__ + "static/media/TicTacToe.aa1d33ac.jpg";